import React from 'react'
import { TabsPanelWithLock } from '../../components/tab-panel-with-lock'
import { ContextToolbar } from '@guillotinaweb/react-gmi'
import { useTraversal } from '@guillotinaweb/react-gmi'
import { PanelPermissions } from '@guillotinaweb/react-gmi'
import { Select } from '@guillotinaweb/react-gmi'
import { Input } from '@guillotinaweb/react-gmi'
import { Loading } from '@guillotinaweb/react-gmi'
import { Button } from '@guillotinaweb/react-gmi'
import { Modal } from '@guillotinaweb/react-gmi'
import { useLocation } from '@guillotinaweb/react-gmi'
import { PanelItems } from '@guillotinaweb/react-gmi'
import { sleep } from '../../common/sleep'

const loadZonas = async (client) => {
  const resp = await client.get('@get-zonas?lang=fr')
  const data = await resp.json()
  return [resp, data]
}

const sortBy = (prop) => (a, b) => {
  const k = `${a[prop]}/`
  const k2 = `${b[prop]}/`
  return k.localeCompare(k2)
}

const selectPaises = (data) => {
  return data.member
    .filter((item) => item.sort[0] === 3)
    .map((item) => ({
      path: item.path,
      value: item.path,
      text: item.localized_text.es,
      route: item.path_i18n,
    }))
    .sort(sortBy('text'))
}

const selectPais = (pais, data) => {
  pais = `${pais}/`
  return data.member
    .filter((item) => item.path.startsWith(pais))
    .sort(sortBy('path'))
}

export function PanelZonas(props) {
  const Ctx = useTraversal()
  const [zonas, setZonas] = React.useState(undefined)
  const [refresh, setRefresh] = React.useState(undefined)
  const [pais, setPais] = React.useState(undefined)
  const [productos, setProductos] = React.useState(undefined)
  const [loadingRegion, setLoadingRegion] = React.useState(false)
  const [region, setRegion] = React.useState(undefined)
  const [moveModal, setMoveModal] = React.useState(undefined)
  const [copyModal, setCopyModal] = React.useState(undefined)
  const [location, navigate] = useLocation()

  const canModify = Ctx.hasPerm('guillotina.ModifyContent')
  const canDelete = Ctx.hasPerm('guillotina.DeleteContent')

  React.useEffect(() => {
    ;(async () => {
      const [, data] = await loadZonas(Ctx.client)
      setZonas(data)
    })()
  }, [refresh])

  const paisParam = location.get('pais')

  React.useEffect(() => {
    if (paisParam) {
      setPais(paisParam)
    }
  }, [paisParam])

  const handlerRegion = async (region, path) => {
    console.log('Region', region, path)
    setLoadingRegion(true)
    const data = await Ctx.client.getProductsRegion(path)
    setProductos(data)
    setRegion({ region, path })
    setLoadingRegion(false)
  }

  return zonas ? (
    <React.Fragment>
      <div className="columns is-size-7">
        <div className="column is-4">
          <div className="field">
            <label className="label">Paises</label>
            <Select
              appendDefault
              options={selectPaises(zonas)}
              onChange={(ev) => navigate({ pais: ev.target.value })}
            />
            {pais && (
              <ZonasWidget
                items={selectPais(pais, zonas)}
                onSelect={handlerRegion}
              />
            )}
          </div>
        </div>
        <div className="column is-8">
          {!zonas && <Loading />}
          {region && (
            <React.Fragment>
              <div className="level is-size-7">
                <div className="level-left">
                  <h1 className="title is-size-5">{region.path}</h1>
                </div>
                <div className="level-right">
                  {canModify && (
                    <Button
                      className="is-small"
                      onClick={(ev) => setCopyModal(true)}
                    >
                      Copiar contenido a otra Región
                    </Button>
                  )}

                  {canModify && (
                    <Button
                      className="is-small"
                      onClick={(ev) => setMoveModal(true)}
                    >
                      Mover Productos
                    </Button>
                  )}

                  <Button
                    className="is-small"
                    onClick={(ev) =>
                      navigate({ path: `${region.path}/`, tab: 'Items' })
                    }
                  >
                    Editar Región
                  </Button>

                  {canDelete && (
                    <Button
                      className="is-small"
                      onClick={() =>
                        Ctx.doAction('removeItems', {
                          items: [{ '@id': region.path }],
                        })
                      }
                    >
                      Eliminar
                    </Button>
                  )}
                </div>
              </div>

              {moveModal && (
                <MoveProducts
                  region={region}
                  items={selectPais(pais, zonas)}
                  close={(e) => setMoveModal(false)}
                  onMove={(ev) => handlerRegion(region.region, region.path)}
                />
              )}

              {copyModal && (
                <CopyContent
                  region={region}
                  items={selectPais(pais, zonas)}
                  close={(e) => setCopyModal(false)}
                />
              )}
            </React.Fragment>
          )}

          {loadingRegion ? (
            <Loading />
          ) : (
            productos && (
              <div className="is-size-6">
                <p>Productos: {productos.items_count}</p>
                <hr />
                {productos.search.map((product) => (
                  <div key={product.id} className="zonas__product">
                    <p>
                      <a
                        onClick={(ev) =>
                          navigate({ path: product.path + '/' }, true)
                        }
                      >
                        {product.id}
                      </a>
                      &nbsp; > &nbsp;
                      <a
                        href={`https://www.vinissimus.fr/fr/vin/${product.id}`}
                        target="_blank"
                      >
                        www
                      </a>
                      &nbsp; > &nbsp;
                      <a
                        href={`/administracion/contenidos/@list-groups?q=${product.id}`}
                        target="_blank"
                      >
                        Grupo
                      </a>
                    </p>
                  </div>
                ))}
                {/* <pre>{JSON.stringify(productos, null, 2)}</pre> */}
              </div>
            )
          )}
        </div>
      </div>
    </React.Fragment>
  ) : null
}

const moveZone = async (client, origin, dest) => {
  const data = {
    source: origin.replace('/zonas', ''),
    dest: dest.replace('/zonas', ''),
  }
  return await client.post('@product-change-region?es_refresh=true', data)
}

const copyContent = async (client, origin, dest) => {
  return await client.post(origin + '/@copy-content', { dest })
}

export function MoveProducts(props) {
  const Ctx = useTraversal()
  const [toRegion, setTo] = React.useState(undefined)
  const [loading, setLoading] = React.useState(false)

  const changeForm = async (ev) => {
    if (!toRegion) {
      alert('Debes especificar un destino')
    }
    setLoading(true)
    ev.preventDefault()
    const resp = await moveZone(Ctx.client, props.region.path, toRegion)
    if (resp.status >= 200 && resp.status < 300)
      Ctx.flash('Region movida. Los datos pueden tardar en aparecer', 'success')
    else Ctx.flash('Algo ha ido mal', 'danger')

    setLoading(false)
    props.close()
    if (props.onMove) props.onMove()
  }

  return (
    <Modal isActive={true} setActive={props.close}>
      <h1 className="title">Mover los productos de:</h1>
      <form action="" onSubmit={changeForm}>
        <div className="field">
          <label htmlFor="">Region: {props.region.path}</label>
        </div>
        <Select
          options={props.items.map((item) => ({
            label: item.path,
            value: item.path,
          }))}
          appendDefault
          onChange={(ev) => setTo(ev.target.value)}
        />
        <br />
        <div className="level level-right">
          <Button loading={loading}>Mover</Button>
        </div>
      </form>
    </Modal>
  )
}

export function CopyContent(props) {
  const Ctx = useTraversal()
  const [toRegion, setTo] = React.useState(undefined)
  const [loading, setLoading] = React.useState(false)

  const changeForm = async (ev) => {
    if (!toRegion) {
      alert('Debes especificar un destino')
    }
    setLoading(true)
    ev.preventDefault()
    await copyContent(Ctx.client, props.region.path, toRegion)
    await sleep(4000)
    setLoading(false)
    Ctx.flash(
      'Contenido copiado. Los datos pueden tardar en aparecer',
      'success'
    )
    props.close()
  }

  return (
    <Modal isActive={true} setActive={props.close}>
      <h1 className="title">Copiar contenido de:</h1>
      <form action="" onSubmit={changeForm}>
        <div className="field">
          <label htmlFor="">Region: {props.region.path}</label>
        </div>
        <Select
          options={props.items.map((item) => ({
            label: item.path,
            value: item.path,
          }))}
          appendDefault
          onChange={(ev) => setTo(ev.target.value)}
        />
        <br />
        <div className="level level-right">
          <Button loading={loading}>Copiar</Button>
        </div>
      </form>
    </Modal>
  )
}

export function ZonasWidget({ items, onSelect = (x) => {} }) {
  const [filter, setFilter] = React.useState('')
  const [current, setCurrent] = React.useState(undefined)

  const selectItems = (f, data) => {
    if (f === '') return data
    return data.filter((item) => item.path.includes(f))
  }

  const setRegion = (region, path) => {
    setCurrent(path)
    onSelect(region, path)
  }

  return (
    <React.Fragment>
      <Input
        className="is-size-7"
        style={{ width: '100%' }}
        placeholder="Filter"
        onChange={(ev) => {
          if (ev.length > 1) {
            setFilter(ev)
          } else {
            setFilter('')
          }
        }}
      />

      <ul className="zonas__widget">
        {selectItems(filter, items).map((item) => (
          <li
            key={item.path}
            className={
              'zonas__level zonas__level__' +
              item.sort[0] +
              (current === item.path ? ' current' : '')
            }
            onClick={(ev) => setRegion(item.path_i18n, item.path)}
          >
            {item.sort[0] > 4 ? '└─' : ''}{' '}
            {item.path
              .split('/')
              .slice(item.sort[0] - 1)
              .join('/')}
          </li>
        ))}
      </ul>
    </React.Fragment>
  )
}

const tabs = {
  Items: PanelItems,
  Zonas: PanelZonas,
  Permissions: PanelPermissions,
}

const tabsPermissions = {
  Items: 'guillotina.ViewContent',
  Permissions: 'guillotina.SeePermissions',
}

export function ZonasView(props) {
  const ctx = useTraversal()
  const calculated = ctx.filterTabs(tabs, tabsPermissions)
  return (
    <TabsPanelWithLock
      tabs={calculated}
      currentTab="Items"
      editableTabs={[]}
      rightToolbar={<ContextToolbar {...props} />}
      {...props}
    />
  )
}
